var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("ShippingEligibilityInfo", { ref: "eligibility" }),
      _vm._v(" "),
      _c(
        "div",
        {
          directives: [
            {
              name: "loading",
              rawName: "v-loading",
              value: _vm.loading,
              expression: "loading",
            },
          ],
        },
        [
          !_vm.isOneOff
            ? _c(
                "el-row",
                { staticClass: "form-row", attrs: { gutter: 20 } },
                [
                  _c("el-col", { attrs: { span: 24 } }, [
                    _c("label", [_vm._v("Old Product")]),
                    _vm._v(" "),
                    _c(
                      "div",
                      { staticClass: "el-input" },
                      [
                        _c("el-input", {
                          attrs: {
                            type: "text",
                            disabled: "",
                            value: _vm.oldProductDescription,
                          },
                        }),
                      ],
                      1
                    ),
                  ]),
                ],
                1
              )
            : _vm._e(),
          _vm._v(" "),
          _vm.productSkus.length > 0 && !_vm.isOneOff
            ? _c(
                "el-row",
                { staticClass: "form-row", attrs: { gutter: 20 } },
                [
                  _c("el-col", { attrs: { span: 24 } }, [
                    _c("label", [_vm._v("Replacement Product")]),
                    _vm._v(" "),
                    _c(
                      "div",
                      { staticClass: "el-input" },
                      [
                        _c(
                          "el-select",
                          {
                            attrs: {
                              filterable: "",
                              "reserve-keyword": "",
                              clearable: "",
                              autocomplete: "off",
                              disabled:
                                !_vm.enabledExchange || _vm.loadingPrices,
                              placeholder: "Please enter a keyword",
                              name: "product_type",
                            },
                            on: { change: _vm.setDevicePrice },
                            model: {
                              value: _vm.request_product.device_price.id,
                              callback: function ($$v) {
                                _vm.$set(
                                  _vm.request_product.device_price,
                                  "id",
                                  $$v
                                )
                              },
                              expression: "request_product.device_price.id",
                            },
                          },
                          _vm._l(_vm.productSkus, function (price) {
                            return _c(
                              "el-option",
                              {
                                key: price.id,
                                attrs: {
                                  disabled:
                                    _vm.isDisabledReplacementProduct(price),
                                  label: _vm.humanFriendlyPrice(price),
                                  value: price.id,
                                },
                              },
                              [
                                _c(
                                  "span",
                                  { class: { orange: price.out_of_stock } },
                                  [
                                    _vm._v(
                                      _vm._s(_vm.humanFriendlyPrice(price)) +
                                        " "
                                    ),
                                  ]
                                ),
                              ]
                            )
                          }),
                          1
                        ),
                      ],
                      1
                    ),
                  ]),
                ],
                1
              )
            : _vm._e(),
          _vm._v(" "),
          _vm.productSkus.length === 0
            ? _c(
                "el-row",
                { staticClass: "form-row", attrs: { gutter: 20 } },
                [
                  _c(
                    "el-col",
                    { attrs: { span: 12 } },
                    [
                      _c("label", [_vm._v("Product Type")]),
                      _vm._v(" "),
                      !_vm.loadingPrices ? _c("RefreshProducts") : _vm._e(),
                      _vm._v(" "),
                      _c(
                        "div",
                        { staticClass: "el-input" },
                        [
                          _c(
                            "el-select",
                            {
                              attrs: {
                                filterable: "",
                                "reserve-keyword": "",
                                clearable: "",
                                autocomplete: "off",
                                disabled:
                                  !_vm.enabledExchange || _vm.loadingPrices,
                                placeholder: "Please enter a keyword",
                                name: "product_type",
                              },
                              on: { change: _vm.productChanged },
                              model: {
                                value: _vm.request_product.new_device_kind,
                                callback: function ($$v) {
                                  _vm.$set(
                                    _vm.request_product,
                                    "new_device_kind",
                                    $$v
                                  )
                                },
                                expression: "request_product.new_device_kind",
                              },
                            },
                            _vm._l(_vm.availableProducts, function (device) {
                              return _c(
                                "el-option",
                                {
                                  key: device.id,
                                  attrs: {
                                    disabled: _vm.productRestricted(device),
                                    label: device.description,
                                    value: device.kind,
                                  },
                                },
                                [
                                  _c(
                                    "span",
                                    { staticStyle: { float: "left" } },
                                    [_vm._v(_vm._s(device.description))]
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "span",
                                    {
                                      staticStyle: {
                                        float: "right",
                                        color: "#8492a6",
                                        "font-size": "13px",
                                      },
                                    },
                                    [
                                      _vm._v(
                                        _vm._s(device.enabled ? "" : "Disabled")
                                      ),
                                    ]
                                  ),
                                ]
                              )
                            }),
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c("el-col", { attrs: { span: 12 } }, [
                    _c("label", [_vm._v("Color")]),
                    _vm._v(" "),
                    _c(
                      "div",
                      { staticClass: "el-input" },
                      [
                        _c(
                          "el-select",
                          {
                            attrs: {
                              filterable: "",
                              clearable: "",
                              autocomplete: "off",
                              disabled: _vm.currentColors.length < 1,
                              placeholder: "Please select color",
                              name: "product_color",
                            },
                            model: {
                              value: _vm.request_product.new_device_color,
                              callback: function ($$v) {
                                _vm.$set(
                                  _vm.request_product,
                                  "new_device_color",
                                  $$v
                                )
                              },
                              expression: "request_product.new_device_color",
                            },
                          },
                          _vm._l(_vm.currentColors, function (color) {
                            return _c("el-option", {
                              key: color.name,
                              attrs: { label: color.name, value: color.name },
                            })
                          }),
                          1
                        ),
                      ],
                      1
                    ),
                  ]),
                ],
                1
              )
            : _vm._e(),
          _vm._v(" "),
          _c("div", [
            !_vm.enabledExchange
              ? _c(
                  "small",
                  { staticStyle: { color: "#F12C2C", margin: "0px 5px" } },
                  [
                    _vm._v(
                      "\n        Exchange is not allowed for this device\n      "
                    ),
                  ]
                )
              : _vm._e(),
            _vm._v(" "),
            _vm.isBaseStationV1
              ? _c("label", { staticStyle: { color: "red" } }, [
                  _vm._v(
                    "For base station replacements, please reference Alarm Desktop for region and version type\n      "
                  ),
                ])
              : _vm._e(),
          ]),
          _vm._v(" "),
          _c(
            "el-row",
            { staticClass: "form-row", attrs: { gutter: 20 } },
            [
              _c(
                "el-col",
                { attrs: { span: 24 } },
                [
                  _c("label", [_vm._v("Reason Group")]),
                  _vm._v(" "),
                  _c(
                    "el-tooltip",
                    {
                      staticClass: "item",
                      attrs: {
                        effect: "dark",
                        content: "Refresh data",
                        placement: "top",
                      },
                    },
                    [
                      _c("RefreshButton", {
                        attrs: { text: false },
                        on: { click: _vm.refreshReasons },
                      }),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "el-input" },
                    [
                      _c(
                        "el-select",
                        {
                          attrs: {
                            filterable: "",
                            clearable: "",
                            autocomplete: "off",
                            disabled: !_vm.request_product.new_device_kind,
                            placeholder: "Please select group",
                            name: "reason_group",
                          },
                          on: {
                            change: function ($event) {
                              return _vm.resetReason()
                            },
                          },
                          model: {
                            value: _vm.request_reasons.reason_group,
                            callback: function ($$v) {
                              _vm.$set(_vm.request_reasons, "reason_group", $$v)
                            },
                            expression: "request_reasons.reason_group",
                          },
                        },
                        _vm._l(_vm.currentGroups, function (group) {
                          return _c("el-option", {
                            key: group.id,
                            attrs: { label: group.value, value: group.id },
                          })
                        }),
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "el-row",
            { staticClass: "form-row", attrs: { gutter: 20 } },
            [
              _c("el-col", { attrs: { span: 24 } }, [
                _c(
                  "div",
                  {
                    staticClass: "clearfix",
                    staticStyle: { "margin-bottom": "5px" },
                  },
                  [
                    _c(
                      "label",
                      [
                        _vm._v("\n            Reason\n            "),
                        _vm.request_reasons.return_label
                          ? _c(
                              "el-tag",
                              {
                                attrs: {
                                  type: "warning",
                                  effect: "plain",
                                  size: "mini",
                                },
                              },
                              [_vm._v("With Return Label")]
                            )
                          : _vm._e(),
                      ],
                      1
                    ),
                  ]
                ),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "el-input" },
                  [
                    _c(
                      "el-select",
                      {
                        attrs: {
                          filterable: "",
                          clearable: "",
                          autocomplete: "off",
                          disabled: !_vm.request_reasons.reason_group,
                          placeholder: "Please select reason",
                          name: "reason",
                        },
                        on: { change: _vm.setReturnLabel },
                        model: {
                          value: _vm.new_reason.id,
                          callback: function ($$v) {
                            _vm.$set(_vm.new_reason, "id", $$v)
                          },
                          expression: "new_reason.id",
                        },
                      },
                      _vm._l(_vm.currentReasons, function (reason) {
                        return _c(
                          "el-option",
                          {
                            key: reason.id,
                            attrs: {
                              label: reason.value + " - " + reason.text,
                              value: reason.id,
                            },
                          },
                          [
                            _c("span", { staticStyle: { float: "left" } }, [
                              _vm._v(
                                _vm._s(reason.value) +
                                  " - " +
                                  _vm._s(reason.text)
                              ),
                            ]),
                            _vm._v(" "),
                            _c(
                              "span",
                              {
                                staticStyle: {
                                  float: "right",
                                  color: "#8492a6",
                                  "font-size": "13px",
                                },
                              },
                              [
                                _vm._v(
                                  _vm._s(
                                    reason.return_label
                                      ? "With Return Label"
                                      : ""
                                  )
                                ),
                              ]
                            ),
                          ]
                        )
                      }),
                      1
                    ),
                  ],
                  1
                ),
              ]),
            ],
            1
          ),
          _vm._v(" "),
          _vm.isAllProductsOutOfStock
            ? _c(
                "el-alert",
                {
                  attrs: {
                    title: "This product is out of stock.",
                    type: "error",
                    "show-icon": "",
                  },
                },
                [
                  _c("span", [
                    _vm._v(
                      "All of the items are out of stock, please consult your supervisor on how to proceed\n      "
                    ),
                  ]),
                ]
              )
            : _vm._e(),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "center-buttons" },
            [
              _c(
                "el-button",
                {
                  attrs: { plain: "" },
                  on: {
                    click: function ($event) {
                      return _vm.back()
                    },
                  },
                },
                [_vm._v("\n        Back\n      ")]
              ),
              _vm._v(" "),
              _c(
                "el-button",
                {
                  attrs: {
                    disabled: _vm.isAllProductsOutOfStock,
                    type: "info",
                    plain: "",
                  },
                  on: {
                    click: function ($event) {
                      return _vm.reset()
                    },
                  },
                },
                [_vm._v("\n        Reset\n      ")]
              ),
              _vm._v(" "),
              _c(
                "el-button",
                {
                  attrs: { disabled: !_vm.isValid, type: "primary", plain: "" },
                  on: {
                    click: function ($event) {
                      return _vm.next()
                    },
                  },
                },
                [_vm._v("\n        Next\n      ")]
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }